import { Environment } from 'Environment';
import { deviceSupportsResource } from '../deviceSupportsResource';

export function configureAndroid(env: Environment) {
	env.initializeSync = true;
	env.supportsResource = resource =>
		deviceSupportsResource(resource, 'application/android');
}
